import React, { useEffect, useState } from 'react';

import { isCommunityCCRC } from 'components/Community/utils';
import { useCommunityInfoContext } from 'components/CommunityInfo/CommunityInfoContext';
import { CommunityContract } from 'types/contracts';

import CommunityFeesPreview from './CommunityFeePreview';
import { useCareTypesContext } from '../CareTypesContext';
import { CommunityFeesType } from '../types';

const CommunityFees = () => {
  const { careType, contract } = useCareTypesContext();
  const { communityInfo } = useCommunityInfoContext();
  const isCcrc = isCommunityCCRC(communityInfo?.rental_types || []);
  const [contractCommunityFee, setContractCommunityFee] = useState<CommunityFeesType | undefined>(undefined);

  useEffect(() => {
    const communityFee = careType?.communityFees.find((item: CommunityFeesType) =>
      (item?.contracts || []).some((contractItem: CommunityContract) => contractItem.id === contract?.id)
    );

    setContractCommunityFee(communityFee);
  }, [careType, contract]);

  return <CommunityFeesPreview fee={contractCommunityFee} isCcrc={isCcrc} />;
};

export default CommunityFees;
